import React, {PureComponent} from "react"

import Flex from "@irati/ui/src/Flex"
import {PlaceholderSquare} from "./"

interface PlaceholderGridProps {
  columns: number,
  rows: number
}

class PlaceholderGrid extends PureComponent<PlaceholderGridProps> {
  render() {
    const {columns, rows} = this.props
    const rowArray = new Array(rows).fill("placholderRow")
    const colArray = new Array(columns).fill("placholderCol")
    const colWidth = `${90 / columns}%`

    return (
      <>
        {rowArray.map((rowLabel, rowIndex) => (
          <Flex justifyContent="space-between" key={`${rowLabel}#${rowIndex}`}>
            {colArray.map((colLabel, colIndex) => (
              <PlaceholderSquare width={colWidth} key={`${colLabel}#${colIndex}`} />
            ))}
          </Flex>
        ))}
      </>
    )
  }
}

export default PlaceholderGrid
